import { cn } from "@omni/utils/styles";

import { useImageContext } from "../../context/image.context";

type Props = {
    className?: string;
};

export const Img = ({ className }: Props) => {
    const {
        alt,
        src,
        lazyLoading,
        desktop,
        mobile: _mobile,
        ...props
    } = useImageContext();

    return (
        <img
            {...props}
            className={cn("tw:w-full tw:h-full", className)}
            src={src ?? undefined}
            srcSet={desktop?.srcSet ?? undefined}
            alt={alt ?? undefined}
            width={desktop?.width ?? undefined}
            height={desktop?.height ?? undefined}
            loading={lazyLoading ? "lazy" : "eager"}
            decoding={lazyLoading ? "async" : "auto"}
            fetchPriority={lazyLoading ? "auto" : "high"}
        />
    );
};
